import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useStoreActions } from 'easy-peasy';
import LinearProgress from '@material-ui/core/LinearProgress';
import {
	getTemplate,
	checkUserToken,
	getPMLink,
	getIsPB,
	saveInfoToLocalStorage,
	deconstructErrorMessage,
	getTemplateType
} from '../utils';
import ErrorComponent from '../components/error/ErrorComponent';
import { BRANDING_TYPE } from '../constants';

const HomeScreen = () => {
	// console.error('HomeScreen cookies', { cookies, jwtToken });
	const [initialized, setInitialized] = useState(false);
	const [isLoading, setIsLoading] = useState(true);
	const setIsSpecial = useStoreActions(actions => actions.token.setIsSpecial);
	// const setReport = useStoreActions(actions => actions.token.setReport);
	const setTemplate = useStoreActions(actions => actions.template.setTemplate);
	const loadTemplate = useStoreActions(actions => actions.template.loadTemplate);

	const history = useHistory();

	useEffect(() => {
		const template = getTemplate();

		// let report = false;
		// if (template.includes('template_report')) {
		// 	report = true;
		// }
		// setReport(report);

		const brandingType = getTemplateType(template);
		window.GM_BRANDING_TYPE = brandingType;
		window.GM_BRANDING_TYPE_REPORT_EBOOK =
			brandingType === BRANDING_TYPE.TYPE_REPORT_COVER ||
			brandingType === BRANDING_TYPE.TYPE_EBOOK_INTRO;

		const pmLink = getPMLink();

		const decodedPMLink = pmLink && pmLink?.length > 0 ? atob(pmLink) : null;
		// console.log('pmLink, decodedPMLink', pmLink, decodedPMLink);
		window.PMLink = decodedPMLink;

		const isPB = getIsPB();

		const decodedIsPB = atob(isPB);
		// console.log('isPB, decodedIsPB', isPB, decodedIsPB);
		if (decodedIsPB === 'true') {
			window.isPB = true;
		} else {
			window.isPB = false;
		}

		checkUserToken()
			.then(({ token, isValidToken, isSpecial }) => {
				setIsSpecial(isSpecial);
				setIsLoading(false);

				if (isValidToken) {
					const template = getTemplate();
					console.error('CheckUserToken', { template });
					setTemplate(template);
					window.selectedTemplate = template;
					window.currentTemplate = template;
					setInitialized(true);
					// at this point save all to localStorage
					saveInfoToLocalStorage(template, isPB, pmLink);

					loadTemplate().then(() => {
						// Mixpanel
						window.gm_optInTracking();
						window.gm_setUser(window.adviserData);

						window.fromHome = true;
						history.replace('/editor');
					});
				}
			})
			.catch(error => {
				setIsLoading(false);
			});
	}, []);

	if (!initialized && !isLoading) {
		const error = {
			code: 401,
			msg: `You need to login first! Please go to <a href="${process.env.REACT_APP_BASE_API_URL}">GoalsMapper</a> to login then refresh this page.`
		};
		return <ErrorComponent {...deconstructErrorMessage(error)} />;
	}

	return <LinearProgress />;
};

HomeScreen.propTypes = {};

export default HomeScreen;
